import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../constants/constants";
import { getCurrentToken, getValueFromStorage } from "../helpers/helpers";

export const AgendaApi = createApi({
  reducerPath: "agenda",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-type", "application/json");
      headers.set("authorization", `Bearer ${getCurrentToken()}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAgenda: builder.query({
      query: ({
        currentPage = 1,
        resultPerPage = 10000,
        event_id = "",
        user_id = "",
        day = "",
      }) => ({
        url: "api/agenda",
        method: "GET",
        params: {
          event_id,
          user_id,
          current_page: currentPage,
          result_per_page: resultPerPage,
          day,
        },
      }),
    }),
    addAgenda: builder.mutation({
      query: (body) => ({
        url: `api/agenda`,
        method: "POST",
        body: body,
      }),
    }),
    deleteAgenda: builder.mutation({
      query: (id) => ({
        url: `api/agenda/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddAgendaMutation,
  useLazyGetAgendaQuery,
  useDeleteAgendaMutation,
} = AgendaApi;
